import Icon from "@mui/material/Icon";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import {
  makeStyles,
  ThemeProvider,
  createTheme
} from "@material-ui/core/styles";
import styles from "assets/jss/style-component/components/sidebarStyle.js";
import classNames from "classnames";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";

import PropTypes from "prop-types";
import React from "react";
import { NavLink } from "react-router-dom";

const useStyles = makeStyles(styles);
const drawerWidth = 190;
const menuWidth = 240;
const menuWidthClose = 40;

export default function MenuPopup(props) {
  const classes = useStyles();

  const widthM = props.open ? drawerWidth : menuWidthClose;

  let selectMenu = 0;
  let selectSubMenu = 0;

  const [anchor, setAnchor] = React.useState(null);
  const [anchorA, setAnchorA] = React.useState(null);

  const [selected, setSelected] = React.useState(0);
  const [selectedA, setSelectedA] = React.useState(0);

  const [selectedNameMenu, setSelectedNameMenu] = React.useState("");

  const [anchorSub, setAnchorSub] = React.useState(null);
  const [anchorSubA, setAnchorSubA] = React.useState(null);

  const [selectedSub, setSelectedSub] = React.useState(0);
  const [selectedSubA, setSelectedSubA] = React.useState(0);

  const openMenu = (event, padre, name) => {
    setAnchor(event.currentTarget);
    setAnchorA(event.currentTarget);
    setSelected(padre);
    setSelectedA(padre);
    setSelectedNameMenu(name);
  };

  const closeMenu = () => {
    setAnchor(null);
    setSelected(0);
  };

  function selectedMenu(e) {
    setAnchor(anchorA);
    setSelected(selectedA);
  }
  //Funciones poara el submenuHijo
  const openMenuSub = (event, padre) => {
    setAnchorSub(event.currentTarget);
    setAnchorSubA(event.currentTarget);
    setSelectedSub(padre);
    setSelectedSubA(padre);
  };

  const closeMenuSub = () => {
    setAnchorSub(null);
    setSelectedSub(0);
  };

  const closeMenuSubCentral = () => {
    setAnchor(null);
    setSelected(0);
    setAnchorSub(null);
    setSelectedSub(0);
  };

  function selectedMenuSub() {
    setAnchor(anchorA);
    setSelected(selectedA);
    setAnchorSub(anchorSubA);
    setSelectedSub(selectedSubA);
  }

  const { color, menu, submenu, submenuhijo } = props;

  submenu.forEach((prop, key) => {
    if (window.location.href.indexOf(prop.layout + prop.path) > -1) {
      selectSubMenu = prop.codigo;
      selectMenu = prop.codigoPadre;
    }
  });

  menu.forEach((prop, key) => {
    if (
      window.location.href.indexOf(prop.layout + prop.path) > -1 &&
      prop.path !== "/"
    ) {
      selectMenu = prop.codigo;
    }
  });

  function activeRoute(routeName) {
    return window.location.href.indexOf(routeName) > -1 ? true : false;
  }

  var links = (
    <List className={classes.list}>
      {menu.map((prop, key) => {
        const listItemClasses = classNames({
          [" " + classes[color]]: prop.codigo === selectMenu
        });
        const whiteFontClasses = classNames({
          [" " + classes.whiteFont]: prop.codigo === selectMenu
        });
        const item = (
          <ListItem
            className={classes.itemLink + listItemClasses}
            onMouseEnter={event => {
              openMenu(
                event,
                prop.codigo,
                prop.name + " (" + prop.codigo + ")"
              );
            }}
            onMouseLeave={closeMenu}
          >
            <Icon className={classNames(classes.itemIcon, whiteFontClasses)}>
              {prop.icon}
            </Icon>
            <ListItemText
              primary={prop.name + " (" + prop.codigo + ")"}
              className={classNames(classes.itemText, whiteFontClasses)}
              disableTypography={true}
            />
          </ListItem>
        );
        return prop.path !== "/" ? (
          <NavLink
            to={prop.layout + prop.path}
            className={classes.item}
            key={key}
          >
            {item}
          </NavLink>
        ) : (
          <div className={classes.item} key={key}>
            {item}
          </div>
        );
      })}
    </List>
  );

  var subMenu = (
    <Menu
      open={Boolean(anchor)}
      anchorEl={anchor}
      onClose={closeMenu}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      elevation={0}
      style={{
        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,1))",
        marginLeft: widthM + "px"
      }}
      className="MenuPopup"
    >
      <div onMouseEnter={selectedMenu} onMouseLeave={closeMenu}>
        {!props.open ? (
          <div className={classes.menuTitle}>{selectedNameMenu}</div>
        ) : (
          ""
        )}
        {submenu.map((prop, key) => {
          const listItemClasses = classNames({
            [" " + classes["gray"]]: prop.codigo === selectSubMenu
          });
          if (selected !== prop.codigoPadre) return "";
          const item = (
            <MenuItem
              onClick={prop.path !== "/" ? closeMenuSubCentral : null}
              className={classes.itemSubmenu + listItemClasses}
            >
              <ListItemIcon>
                <Icon> {prop.icon} </Icon>
              </ListItemIcon>
              {prop.name + " (" + prop.codigo + ")"}
            </MenuItem>
          );
          return prop.path !== "/" ? (
            <NavLink
              to={prop.layout + prop.path}
              key={key}
              onMouseEnter={event => {
                openMenuSub(event, prop.codigo);
              }}
              onMouseLeave={closeMenuSub}
            >
              {item}
            </NavLink>
          ) : (
            <div
              key={key}
              onMouseEnter={event => {
                openMenuSub(event, prop.codigo);
              }}
              onMouseLeave={closeMenuSub}
            >
              {item}
            </div>
          );
        })}
      </div>
    </Menu>
  );

  var subMenuHijoView = (
    <Menu
      open={Boolean(anchorSub)}
      anchorEl={anchorSub}
      onClose={closeMenuSub}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      elevation={0}
      style={{
        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,1))",
        marginLeft: widthM + menuWidth + "px"
      }}
      className="MenuPopup"
    >
      <div onMouseEnter={selectedMenuSub} onMouseLeave={closeMenuSubCentral}>
        {submenuhijo.map((prop, key) => {
          const listItemClasses = classNames({
            [" " + classes[color]]:
              activeRoute(prop.layout + prop.path) && prop.path !== "/"
          });
          if (selectedSub !== prop.codigoPadre) return "";
          return (
            <NavLink to={prop.layout + prop.path} key={key}>
              <MenuItem
                onClick={closeMenuSubCentral}
                className={classes.itemLink + listItemClasses}
              >
                <ListItemIcon>
                  <Icon>{prop.icon}</Icon>
                </ListItemIcon>
                {prop.name}
              </MenuItem>
            </NavLink>
          );
        })}
      </div>
    </Menu>
  );

  return (
    <ThemeProvider theme={theme}>
      {links}
      {subMenu}
      {subMenuHijoView}
    </ThemeProvider>
  );
}

const theme = createTheme({
  components: {
    MuiList: {
      styleOverrides: {
        root: {
          padding: "0 !important"
        }
      }
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          minWidth: "0px !important"
        }
      }
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: "35px !important"
        }
      }
    }
  }
});

MenuPopup.propTypes = {
  open: PropTypes.bool,
  menu: PropTypes.array,
  submenu: PropTypes.array,
  submenuhijo: PropTypes.array,
  color: PropTypes.string
};
